module.exports = __webpack_public_path__ + "img/digital_space_bg_top2.d27e666b.svg";